import type { PostLikesData } from '@/types';
import { Heart } from '@phosphor-icons/react/dist/ssr';
import classnames from 'classnames';
import { type MouseEventHandler, forwardRef } from 'react';

export type LikeButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  data: PostLikesData;
  iconSize?: number;
  styles?: any;
  onClick?: MouseEventHandler;
  buttonType: HTMLButtonElement['type'];
};

export const LikeButton = forwardRef<HTMLButtonElement, LikeButtonProps>(
  ({ data, styles, onClick, buttonType, iconSize = 20 }, ref) => {
    return (
      <button
        ref={ref}
        type={buttonType}
        onClick={onClick}
        className={classnames('flex justify-center', styles?.button)}
      >
        <Heart size={iconSize} weight={data?.isLiked ? 'fill' : undefined} />
        {typeof data?.likesCount !== 'undefined' ? data.likesCount : ''}
      </button>
    );
  },
);
